import { render } from "./ProjectsListDev.vue?vue&type=template&id=6f556f8d&scoped=true"
import script from "./ProjectsListDev.vue?vue&type=script&lang=js"
export * from "./ProjectsListDev.vue?vue&type=script&lang=js"

import "./ProjectsListDev.vue?vue&type=style&index=0&id=6f556f8d&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f556f8d"]])

export default __exports__